import * as API from "middleware/api";

export const validateThirdPayment = (params) => API.executeWithAccessToken("/transfers.third.parties", { ...params });

export const loadListRequest = (filters) => API.executeWithAccessToken("read.batch.transfers", { ...filters });

export const downloadTransactionLinestMiddleware = (format, transactionLines) =>
    API.executeWithAccessToken("/transactionLines.download", { format, transactionLines });

export const downloadListRequestMiddleware = (params) =>
    API.executeWithAccessToken("/listThirdPayment.download", { ...params });

export const downloadTransactionFiletMiddleware = (
    format,
    transactionLines,
    typePayment,
    fileNam,
    id,
    reference,
    dateProcess,
    transactionOrder,
    currency,
    idTransactionStatus,
    accountName,
    isDetailDownload,
) =>
    API.executeWithAccessToken("/transactionLines.file.download", {
        format,
        transactionLines,
        typePayment,
        fileNam,
        id,
        reference,
        dateProcess,
        transactionOrder,
        currency,
        idTransactionStatus,
        accountName,
        isDetailDownload,
    });

export const downloadConfirmation = (summary) =>
    API.executeWithAccessToken("/thirdPayment.downloadConfirm", { summary });

export const downloadDocumentMiddleware = (fileId) => API.executeWithAccessToken("/files.download", { idFile: fileId });

export const validateDateMiddleware = (dateProcess) => API.executeWithAccessToken("/misc.get.firstBusinessDay", { dateProcess });

export const recollectionJWT = (params) => API.executeWithAccessToken("/payment.recollection.jwt", { ...params });

export const payrollUploadDocument = (params) => API.executeWithAccessToken("/payroll.document.upload", { ...params });

export const payrollDeleteDocument = (params) => API.executeWithAccessToken("/payroll.document.delete", { ...params });

export const payrollSend = (params) => API.executeWithAccessToken("/payroll.send", { ...params });

export const downloadPayrollTemplate = (params) => API.executeWithAccessToken("/files.download.template", { ...params });

export const payrollListDownloads = (params) => API.executeWithAccessToken("/payroll.downloads.list", { ...params });

export const payrollGetDownload = (params) => API.executeWithAccessToken("/payroll.downloads.get", params);
